module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "type-wrap"
  }, [_c('router-link', {
    staticClass: "home-page",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页>")]), _vm._v(" "), _c('span', {
    staticClass: "type-name"
  }, [_vm._v("伟嘉视角")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container clearfix"
  }, [_c('Menubar', {
    attrs: {
      "menu-list": _vm.articleTypeArr
    },
    on: {
      "sub-menu-click": _vm.subMenuClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ArticleList', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleList.length > 0),
      expression: "articleList.length > 0"
    }],
    attrs: {
      "articleList": _vm.articleList,
      "article-time": 'addDate',
      "show-copy-right": false
    },
    on: {
      "item-click": _vm.articleClick
    }
  }), _vm._v(" "), _c('Loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.articleList.length === 0),
      expression: "articleList.length === 0"
    }],
    attrs: {
      "height": 100,
      "is-no-more": _vm.articleListNoMore
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagebox"
  }, [_c('Pagination', {
    attrs: {
      "count": _vm.count,
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize
    },
    on: {
      "on-page-click": _vm.onPageClick
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v("伟嘉视角")]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v("COMPANY PERSPECTIVE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-ae05ef72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/perspective.vue
// module id = 619
// module chunks = 1